import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges
} from '@angular/core';

@Directive({
  selector: '[requiredAsterisk]',
  standalone: false
})
export class RequiredAsteriskDirective implements OnChanges {
  private asteriskElement: HTMLElement | null = null;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  @Input('requiredAsterisk') addAsterisk?: boolean | '';

  ngOnChanges(changes: SimpleChanges): void {
    if ('addAsterisk' in changes) {
      const shouldShowAsterisk =
        this.addAsterisk === true || this.addAsterisk === '';

      if (shouldShowAsterisk && !this.asteriskElement) {
        this.asteriskElement = this.renderer.createElement('span');
        this.renderer.addClass(this.asteriskElement, 'required-field-asterisk');

        const text = this.renderer.createText('*');
        this.renderer.appendChild(this.asteriskElement, text);

        this.renderer.appendChild(this.el.nativeElement, this.asteriskElement);
      } else if (!shouldShowAsterisk && this.asteriskElement) {
        this.renderer.removeChild(this.el.nativeElement, this.asteriskElement);
        this.asteriskElement = null;
      }
    }
  }
}
